import AggregateProto from './aggregate-proto';

export default class AggregateBoolean extends AggregateProto {

    checkedTotal() {
        //data should be array of boolean
        const selected = _.filter(this.data).length;
        const all = this.data.length;

        return {selected, all}
    }

    checkedNotChecked() {
        //data should be array of boolean
        const selected = _.filter(this.data).length;
        const notChecked = this.data.length - selected;

        return {selected, notChecked}
    }
}